// extracted by mini-css-extract-plugin
export default {"wrapper":"Skills_wrapper__PBw9H","skillsBlock":"Skills_skillsBlock__A--Th","allSkillsBlock":"Skills_allSkillsBlock__a4VGv"};